/**
 * Console diagnostics meant for local development only.
 *
 * `import.meta.env.DEV` is statically replaced by Vite, so in a production build
 * the condition folds to `false` and the body is dropped by dead-code
 * elimination. Use these instead of bare `console.log` / `console.warn` for
 * messages that fire on hot paths (e.g. every analytics event) or that would
 * print user-scoped payloads into the browser console of real users.
 */
export const devLog = (...args: unknown[]) => {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
};

export const devWarn = (...args: unknown[]) => {
  if (import.meta.env.DEV) {
    console.warn(...args);
  }
};
